import React, { useState, useRef, useEffect } from 'react';
import logo_white from '../../media/logo_white.svg';
import { useLanguage } from '../../providers/preferenceProvider';
import { useToast } from '../../providers/toastProvider';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../css/bar.css';
import { ApiClient } from '../../api/api-client';
import { getUser } from '../../api/user-api';
import { useConfig } from '../../providers/configProvider';
import { ACL } from '../../acls';

const NavBar = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const { config, isAuthorized } = useConfig();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef();
  const [user, setUser] = useState({});
  const { showToast } = useToast();

  window.showGlobalToast = showToast;

  const logout = () => {
    ApiClient.getInstance().logoutUser().then(() => {
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('username');
      window.location.href = '/';
    }).catch((error) => {
      console.error('Logout failed:', error);
      navigate('');
    });
  };

  function checkAdmin() {
    return isAuthorized(ACL.ADMIN_PANEL);
  }

  function checkCompany() {
    return user.companyId
  }

  function checkCompanyManager() {
    return user.companyId && user.companyManager
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (config.user) {
      getUser(config.user.id).then((response) => {
        setUser(response.data.user);
      }).catch((error) => {
        console.error('Failed to fetch account:', error);
      })
    }
  }, [config]);

  return (
    <>
      <header className="header">
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
        <div className="left-section">
          <div className="logo-section">
            <Link to="/home"><img className="logo" src={logo_white} alt="42Workspace" /></Link>
            <div className="vertical-stripe"></div>
          </div>
          <ul className={`nav-list${menuOpen ? ' open' : ''}`}>
            <li className={`nav-item ${location.pathname === '/home' ? 'active' : ''}`}>
              <Link to="/home" onClick={() => setMenuOpen(false)}>{t.home}</Link>
            </li>
            <li className={`nav-item ${location.pathname === '/book' ? 'active' : ''}`}>
              <Link to="/book" onClick={() => setMenuOpen(false)}>{t.book}</Link>
            </li>
            <li className={`nav-item ${location.pathname === '/bookings' ? 'active' : ''}`}>
              <Link to="/bookings" onClick={() => setMenuOpen(false)}>{t.bookings}</Link>
            </li>
            <li className={`nav-item ${location.pathname === '/information' ? 'active' : ''}`}>
              <Link to="/information" onClick={() => setMenuOpen(false)}>{t.information}</Link>
            </li>
            {(checkCompanyManager()) ? (
              <li className={`nav-item ${location.pathname === '/company' ? 'active' : ''}`}>
                <Link to="/company" onClick={() => setMenuOpen(false)}>{t.manage_company}</Link>
              </li>
            ) : null}
            {(checkAdmin()) ? (
              <li className={`nav-item ${location.pathname === '/admin' ? 'active' : ''}`}>
                <Link to="/admin" onClick={() => setMenuOpen(false)}>{t.admin}</Link>
              </li>
            ) : null}
          </ul>
        </div>
        <div className="flex flex-row gap-4 mr-4 ">
          <div className='flex items-center justify-center'>
            {isAuthorized(ACL.USE_CREDITS) && <h1 className='text-white'>Credits: {user.credits}</h1>}
          </div>
          <div className="user-section" ref={dropdownRef}>
            <div className="account-circle bg-white" onClick={() => setDropdownOpen(!dropdownOpen)}>
              <img
                src={user.image}
                alt="Account"
                className="bar-account-image"
              />
            </div>
            {dropdownOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-username">
                  {config.user.name}
                </div>
                <hr className="dropdown-divider" />
                <Link to="/account" onClick={() => {setMenuOpen(false); setDropdownOpen(false);}} className="dropdown-item">{t.my_account}</Link>
                {(checkCompany()) ? (
                  <Link to="/company" onClick={() => {setMenuOpen(false); setDropdownOpen(false);}} className="dropdown-item">{t.my_company}</Link>
                ) : null}
                <Link to="/settings" onClick={() => {setMenuOpen(false); setDropdownOpen(false);}} className="dropdown-item">{t.settings}</Link>
                <hr className="dropdown-divider" />
                <button className="dropdown-item" onClick={logout}>{t.logout}</button>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default NavBar;
